export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-10 md:mb-16">
          <div className="col-span-2 md:col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/205390b4-ccff-46e5-9dd3-9143091b163d.png"
              alt="栄伸株式会社"
              className="h-8 md:h-12 w-auto object-contain brightness-0 invert mb-3"
            />
            <p className="text-xs md:text-sm text-gray-400 leading-relaxed">
              日本料理と経営コンサルティング<br />飲食業界のトータルパートナー
            </p>
            <p className="text-xs md:text-sm text-gray-400 leading-relaxed mt-3">
              〒231-0806 神奈川県横浜市中区本牧町2丁目304加藤ビル303D室
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              Newsletter
            </h3>
            <div className="relative">
              <input
                type="email"
                placeholder="メールアドレス"
                className="w-full bg-transparent border-b border-gray-600 py-2 pr-8 text-xs md:text-sm text-white placeholder-gray-500 focus:outline-none focus:border-teal-500 transition-colors"
              />
              <button className="absolute right-0 top-2 text-gray-400 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-arrow-right-line text-sm"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2">最新情報をお届けします</p>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              Quick Links
            </h3>
            <ul className="space-y-2 md:space-y-3">
              {[
                { href: '#restaurants', label: '花木流味噌 五反野店' },
                { href: '#consulting', label: 'コンサルティング' },
                { href: '#contact', label: '採用情報' },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-xs md:text-sm text-gray-400 hover:text-teal-500 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold text-gray-300 mb-3 md:mb-4 uppercase tracking-wider">
              Follow Us
            </h3>
            <ul className="space-y-2 md:space-y-3">
              {['Instagram', 'Facebook', 'LinkedIn'].map((sns) => (
                <li key={sns}>
                  <a href="#" className="text-xs md:text-sm text-gray-400 hover:text-teal-500 transition-colors cursor-pointer">
                    {sns}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 md:pt-8">
          <div className="text-center">
            <p className="text-3xl md:text-8xl font-bold text-teal-900/30 tracking-tight">
              EISHIN
            </p>
          </div>
        </div>
      </div>

      <div className="bg-slate-900 py-3 md:py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <p className="text-center text-xs md:text-sm text-gray-500">
            © 2025 栄伸株式会社. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
